import React, { useMemo, useState } from 'react';
import { SearchIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Avatar } from '../../components/ui/Avatar';
import { inputClass } from '../../components/ui/Field';
import { feeYears } from '../../data/fees';
import { formatDate, fullName, memberTypeClass, memberTypeLabel } from '../../utils/labels';
export function AdminFees() {
  const {
    fees,
    members,
    setFeePaid,
    pushToast
  } = useApp();
  const [leto, setLeto] = useState(2026);
  const [iskanje, setIskanje] = useState('');
  const [samoNeplacane, setSamoNeplacane] = useState(false);
  const vrstice = useMemo(() => fees.filter(f => f.leto === leto).map(f => ({
    f,
    m: members.find(x => x.id === f.memberId)!
  })).filter(r => !!r.m).filter(r => iskanje ? fullName(r.m).toLowerCase().includes(iskanje.toLowerCase()) : true).filter(r => samoNeplacane ? !r.f.placano : true), [fees, members, leto, iskanje, samoNeplacane]);
  const vseLeto = fees.filter(f => f.leto === leto);
  const placanih = vseLeto.filter(f => f.placano).length;
  const znesekZbran = vseLeto.filter(f => f.placano).reduce((s, f) => s + f.znesek, 0);
  const znesekSkupaj = vseLeto.reduce((s, f) => s + f.znesek, 0);
  return <div className="space-y-5" data-id="element-1052" data-mp="7m3uxpb38ay4">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-1053" data-mp="2mratcblphz8">
        <div data-id="element-1054" data-mp="2okgopee3y66">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-1055" data-mp="2kwllltar3pc">Članarine</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1056" data-mp="hd88qlp11prd">Pregled plačil po letih.</p>
        </div>
        <div className="flex gap-1.5" data-id="element-1057" data-mp="cjcg7yrj8v3l">
          {feeYears.map(y => <button key={y} onClick={() => setLeto(y)} aria-pressed={leto === y} className={`rounded-lg border px-3.5 py-2 text-sm font-medium transition-colors duration-150 ease-out ${leto === y ? 'border-green-500 bg-green-500 text-white' : 'border-line bg-white text-ink-muted hover:bg-canvas hover:text-ink'}`} data-id="element-1058" data-mp="3kzyxmxy561uv">
              {y}
            </button>)}
        </div>
      </div>

      <div className="grid gap-3 sm:grid-cols-3" data-id="element-1059" data-mp="1xpe3aebodi3k">
        <Card className="p-4" data-id="element-1060" data-mp="1106k3cyj3l2t">
          <p className="text-2xl font-semibold text-ink" data-id="element-1061" data-mp="110yewlkaxes1">
            {placanih}
            <span className="text-base font-normal text-ink-muted" data-id="element-1062" data-mp="15xyd6aawtd8l"> / {vseLeto.length}</span>
          </p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-1063" data-mp="19za20dlylufq">Plačanih članarin</p>
        </Card>
        <Card className="p-4" data-id="element-1064" data-mp="1ezoatxvdx8et">
          <p className="text-2xl font-semibold text-ink" data-id="element-1065" data-mp="1f0poma3sc908">{znesekZbran} €</p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-1066" data-mp="2legp7ydcdx3v">Zbrano od {znesekSkupaj} €</p>
        </Card>
        <Card className="p-4" data-id="element-1067" data-mp="2qda0dk55pc0v">
          <p className="text-2xl font-semibold text-ink" data-id="element-1068" data-mp="2qgo3iuln9p9d">{vseLeto.length - placanih}</p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-1069" data-mp="30hqea7z2sj21">Še neporavnanih</p>
        </Card>
      </div>

      <Card className="p-4" data-id="element-1070" data-mp="2vli5rdfdvo3u">
        <div className="grid gap-3 sm:grid-cols-2 lg:w-2/3" data-id="element-1071" data-mp="2qsgnqwjvr8g1">
          <div className="relative" data-id="element-1072" data-mp="2qqvtz95e3tj8">
            <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1073" data-mp="2mrd6q6q3j6d8" />
            <input value={iskanje} onChange={e => setIskanje(e.target.value)} placeholder="Išči po imenu…" aria-label="Išči člane" className={`${inputClass} pl-9`} data-id="element-1074" data-mp="2hsabfdzx4eig" />
          </div>
          <label className="flex items-center gap-2 rounded-lg border border-line px-3 py-2 text-[13px] text-ink" data-id="element-1075" data-mp="23s91l91odwqu">
            <input type="checkbox" checked={samoNeplacane} onChange={e => setSamoNeplacane(e.target.checked)} className="h-4 w-4 rounded border-line accent-green-500" data-id="element-1076" data-mp="627u3botpedj" />
            Prikaži samo neporavnane
          </label>
        </div>
      </Card>

      <Card className="overflow-hidden" data-id="element-1077" data-mp="e3fbol7jiqix">
        <div className="overflow-x-auto viva-scroll" data-id="element-1078" data-mp="e12yelcq94c7">
          <table className="w-full min-w-[760px] text-left text-sm" data-id="element-1079" data-mp="461c260mqmv">
            <thead className="border-b border-line bg-canvas text-[12px] uppercase tracking-wide text-ink-muted" data-id="element-1080" data-mp="44zouufjq3f8">
              <tr data-id="element-1081" data-mp="3migxdrg3m8ar">
                <th className="px-5 py-3 font-medium" data-id="element-1082" data-mp="3mhxpl3k5x0ag">Član</th>
                <th className="px-4 py-3 font-medium" data-id="element-1083" data-mp="3r9fgszwdvmi8">Tip članstva</th>
                <th className="px-4 py-3 font-medium" data-id="element-1084" data-mp="3rbs7q2k4d77f">Znesek</th>
                <th className="px-4 py-3 font-medium" data-id="element-1085" data-mp="3cluhzi6jk9g4">Datum plačila</th>
                <th className="px-4 py-3 font-medium" data-id="element-1086" data-mp="3hjcq56cqikn2">Status</th>
                <th className="px-4 py-3" data-id="element-1087" data-mp="3hhtbfk6q8hne" />
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-1088" data-mp="33kmqpk2g08vj">
              {vrstice.map(({
              f,
              m
            }) => <tr key={m.id} className="transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-1089" data-mp="38io880k8004w">
                  <td className="px-5 py-3" data-id="element-1090" data-mp="2oxo4q4mcu6o7">
                    <span className="flex items-center gap-3" data-id="element-1091" data-mp="2jyl0uni426ht">
                      <Avatar member={m} size="sm" data-id="element-1092" data-mp="2k0fle0pgzwld" />
                      <span className="font-medium text-ink" data-id="element-1093" data-mp="2xych6uw3nyyz">{fullName(m)}</span>
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-1094" data-mp="2tuxslfu3ia9x">
                    <Badge className={memberTypeClass[m.type]} data-id="element-1095" data-mp="37w0g7x0qnsmy">{memberTypeLabel[m.type]}</Badge>
                  </td>
                  <td className="px-4 py-3 text-ink" data-id="element-1096" data-mp="32xywrazehray">{f.znesek} €</td>
                  <td className="px-4 py-3 text-ink-muted" data-id="element-1097" data-mp="3hm3fug2d84u9">
                    {f.datumPlacila ? formatDate(f.datumPlacila) : '—'}
                  </td>
                  <td className="px-4 py-3" data-id="element-1098" data-mp="3cnig0hr0zn6c">
                    {f.placano ? <Badge className="bg-green-50 text-green-700 border-green-200" dot="bg-green-500" data-id="element-1099" data-mp="3qnt6hjofazqz">
                        Poravnano
                      </Badge> : <Badge className="bg-amber-50 text-amber-800 border-amber-200" data-id="element-1100" data-mp="2jbbotc0hsn6k">Neporavnano</Badge>}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-1101" data-mp="2o792fakdfffn">
                    {f.placano ? <Button size="sm" variant="ghost" onClick={() => setFeePaid(m.id, f.leto, false)} data-id="element-1102" data-mp="2s8udcqdchjn7">
                        Prekliči
                      </Button> : <Button size="sm" variant="secondary" onClick={() => {
                  setFeePaid(m.id, f.leto, true);
                  pushToast(`Članarina za ${fullName(m)} je označena kot plačana.`);
                }} data-id="element-1103" data-mp="320i7x0577gsw">
                        Označi kot plačano
                      </Button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}